module.exports = __webpack_public_path__ + "img/Mahajunga.7828a26b.png";